<template>
    <nav class="navbar navbar-expand-sm bg-dark navbar-dark">
        <div class="container-fluid">

        </div>
    </nav>
    <div class="container mt-4" style="text-align: center;">
        <h1 v-if="systemName == 'recommend'" style="font-weight: bold;font-size: 40px;">運動項目推薦後台管理</h1>
        <h1 v-else style="font-weight: bold;font-size: 40px;">運動行為調查後台管理</h1>
        <button class="btn" @click="getUserID(), setLoginType('line')">
            <img src="@/assets/loginline.png" alt="Login with Line" />
        </button>
    </div>
</template>

<script>
import axios from "axios";
import liff from "@line/liff";

export default {
    name: "LoginPage",
    data() {
        return {
            systemName: window.VUE_APP_System, //recommend //behavior
            isDev: window.VUE_APP_Dev,
            lineUserID: null,
            myLiffId: '2002453323-20Lo31Kp',
            isSuccess: false,
            messageerror: '',
            userID: null,
            userName: null,
            userPhoto: null,
            userLoginType: '',
            accessToken: "", // Replace this with the actual access token from your app
            lineLoginChannelID: '2002453323', // Replace this with your Line Login Channel ID
        }
    },
    computed: {

    },
    beforeMount() {
        this.userLoginType = localStorage.getItem("userLoginType");
        let lineResult = localStorage.getItem("LIFF_STORE:2002453323-20Lo31Kp:decodedIDToken");
        if (self.systemName == "recommend") {
            lineResult = localStorage.getItem("LIFF_STORE:2002453331-wK4xYK9O:decodedIDToken");
        }

        if (this.isDev != '1') {
            if (lineResult) {
                try {
                    const lineObject = JSON.parse(lineResult);
                    const linecode = lineObject.sub;
                    localStorage.setItem("linecode", linecode);
                } catch (error) {
                    console.log(error)
                }
                this.$router.push('/register');
            }
        }
    },
    mounted() {
    },
    methods: {
        cleanCatch() {
            localStorage.removeItem('userLoginType');
            localStorage.removeItem('linecode');
            localStorage.removeItem('idToken');
            //    localStorage.removeItem('googlecode');
            localStorage.removeItem('LIFF_STORE:2002453331-wK4xYK9O:loginTmp');
            localStorage.removeItem('LIFF_STORE:2002453323-20Lo31Kp:loginTmp');
        },
        setLoginType(x) {
            this.userLoginType = x;
            localStorage.setItem("userLoginType", x);
        },
        checkIfInClient() {
            this.getUserID();
            if (liff.isInClient()) {
                // 在手機上操作
                this.setUserDo();
            } else {
                // 不在手機上操作
                alert('請使用手機操作');
            }
        },
        async getUserID() {
            if (this.systemName == "recommend") {
                //運動建議
                this.myLiffId = '2002453331-wK4xYK9O';
            }
            liff
                .init({
                    liffId: this.myLiffId
                })
                .then(() => {
                    if (liff.isLoggedIn()) {
                        const idtoken = liff.getIDToken();
                        console.log(idtoken)
                        const accessToken = liff.getAccessToken();
                        this.accessToken = accessToken;
                        localStorage.setItem("accessToken", accessToken);
                        // this.setUserDo(accessToken);

                    } else {
                        liff.login();
                    }

                })
                .catch((err) => {
                    alert('啟動失敗。' + err);
                });
        },
        setUserDo(x) {
            if (this.systemName == "recommend") {
                //運動建議
                this.lineLoginChannelID = '2002453331';
            }
            const url = "https://api.line.me/oauth2/v2.1/verify";
            const params = new URLSearchParams();
            params.append('id_token', x); // 確保 this.accessToken 包含有效的 id_token
            params.append('client_id', this.lineLoginChannelID);

            axios.post(url, params, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
                .then((response) => {
                    console.log('response')
                    console.log(response)
                    const data = response.data;
                    if (data.sub) {
                        this.isSuccess = true;
                        this.userID = data.sub;
                        this.userName = data.name || "Unknown";
                        localStorage.setItem("linedata", data);
                        localStorage.setItem("linesub", data.sub);
                        localStorage.setItem("linename", data.name);
                        // alert('Line登入成功');
                    }
                })
                .catch((error) => {
                    // 處理錯誤
                    console.error("Error:", error.response.data);
                    alert('Line登入失敗' + error.response.data);
                });
        },
    }
};
</script>

 
 